import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const BugRedirect = () => {
    const { bugId } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        const resolveBugId = async () => {
            try {
                // Search for bug by visual ID (bugId field) specifically using bugId parameter
                const { data } = await axios.get(`/api/bugs?bugId=${bugId}&pageSize=10&includeArchived=true`);

                // Find match in the returned results (try exact first, then case-insensitive)
                let bug = data.data.find(b => b.bugId === bugId);
                if (!bug) {
                    bug = data.data.find(b => b.bugId?.toLowerCase() === bugId.toLowerCase());
                }

                if (bug) {
                    navigate(`/bugs/${bug.bugId}`, { replace: true });
                } else {
                    setError(`Bug "${bugId}" not found in your accessible projects.`);
                    toast.error(`Could not find bug: ${bugId}`);
                }
            } catch (err) {
                console.error('Redirection error:', err);
                setError('Failed to resolve bug reference.');
                toast.error('Error finding referenced bug');
            }
        };

        if (bugId) {
            resolveBugId();
        }
    }, [bugId, navigate]);

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
                <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center animate-in fade-in zoom-in-95 duration-300">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <h2 className="text-xl font-bold text-gray-900 mb-2">Reference Error</h2>
                    <p className="text-gray-600 mb-6">{error}</p>
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="w-full py-2 px-4 bg-[#0052CC] hover:bg-[#0065FF] text-white font-bold rounded-lg transition-colors"
                    >
                        Return to Dashboard
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0052CC] mx-auto mb-4"></div>
                <p className="text-gray-500 font-medium">Redirecting to {bugId}...</p>
            </div>
        </div>
    );
};

export default BugRedirect;
